import { Controller } from "@hotwired/stimulus"
import { fetchWithCsrf } from "../util/common"

// Connects to data-controller="table-floating-panel"
export default class extends Controller {
  static targets = ["panel", "selectionCounter", "mergeBtn"]
  static values = { bulkActionsUrl: String }

  connect() {
    this.element.addEventListener("tableSelection:change", this.handleCheckboxSelection.bind(this))
  }

  handleCheckboxSelection(event) {
    this.selectedIds = event.detail.selectedIds || []
    const count = this.selectedIds.length

    const isNoRecordsSelected = count === 0

    if (this.hasSelectionCounterTarget) {
      this.selectionCounterTarget.textContent = isNoRecordsSelected ? "" : `${count} selected`
    }
    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("hidden", isNoRecordsSelected)
    }
    if (this.hasMergeBtnTarget) {
      this.mergeBtnTarget.disabled = count <= 1
    }
  }

  async delete() {
    await this.performBulkAction('delete')
  }

  async merge() {
    await this.performBulkAction('merge')
  }

  async performBulkAction(actionType) {
    const params = new URLSearchParams()
    this.selectedIds.forEach(id => {
      params.append('ids[]', id)
    })
    params.append('action_type', actionType)
    const urlWithParams = `${this.bulkActionsUrlValue}?${params.toString()}`

    try {
      const response = await fetchWithCsrf(urlWithParams, { method: "GET" })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
        document.dispatchEvent(new CustomEvent('modal:show', { bubbles: true }))
      }
    } catch (error) {
      console.error('Failed to load confirmation modal:', error)
    }
  }
}
